module.exports = __webpack_public_path__ + "img/logo_white_eng.2f88b712.svg";